import './i18n';
import { Routes, Route, Navigate, Outlet, useParams } from 'react-router-dom';
import './App.css';
import ShipmentManagerScreen from './app/shipments_manager/views/ShipmentManagerScreen';
import React from 'react';
import AddShipmentScreen from './app/shipments_manager/views/AddShipmentScreen';
import './App.css';
import EditShipmentScreen from './app/shipments_manager/views/EditShipmentScreen';
import LoginScreen from './app/authentication/views/LoginScreen';
import CustomerLoginScreen from './app/authentication/views/CustomerLoginScreen';
import HomeScreen from './app/home/views/HomeScreen';
import CustomerHomeScreen from './app/home/views/CustomerHomeScreen';
import CustomerShipmentTrackingScreen from './app/home/views/CustomerShipmentTrackingScreen';
import CustomerMyShipmentsScreen from './app/home/views/CustomerMyShipmentsScreen';
import CustomerMyInvoicesScreen from './app/home/views/CustomerMyInvoicesScreen';
import CustomerMyPaymentsScreen from './app/home/views/CustomerMyPaymentsScreen';
import PricingRulesManagerScreen from './app/pricing_rules/views/PricingRulesManagerScreen';
import AddPricingRuleScreen from './app/pricing_rules/views/AddPricingRuleScreen';
import EditPricingRuleScreen from './app/pricing_rules/views/EditPricingRuleScreen';
import ImportPricingRulesScreen from './app/pricing_rules/views/ImportPricingRulesScreen';
import PricingPlansManagerScreen from './app/pricing_plans/views/PricingPlansManagerScreen';
import AddPricingPlanScreen from './app/pricing_plans/views/AddPricingPlanScreen';
import PricingPlanDetailScreen from './app/pricing_plans/views/PricingPlanDetailScreen';
import SettlementGroupsManagerScreen from './app/settlement_groups/views/SettlementGroupsManagerScreen';
import AddSettlementGroupScreen from './app/settlement_groups/views/AddSettlementGroupScreen';
import SettlementGroupDetailScreen from './app/settlement_groups/views/SettlementGroupDetailScreen';
import { MaterialThemeWithDataGridLocale } from './app/main/theme/MaterialThemeWithDataGridLocale';
import { JoyDirectionalCssVarsProvider } from './app/main/theme/JoyDirectionalCssVarsProvider';
import CssBaseline from '@mui/material/CssBaseline';
import AddInvoiceScreen from './app/invoices/views/AddInvoiceScreen';
import EditInvoiceScreen from './app/invoices/views/EditInvoiceScreen';
import InvoiceManagerScreen from './app/invoices/views/InvoiceManagerScreen';
import AddCustomerScreen from './app/customers/view/AddCustomerScreen';
import EditCustomerScreen from './app/customers/view/EditCustomerScreen';
import CustomerManagerScreen from './app/customers/view/CustomerManagerScreen';
import CustomerRegistrationApprovalsScreen from './app/customers/view/CustomerRegistrationApprovalsScreen';
import ImportShipmentsScreen from './app/shipments_manager/views/ImportShipmentsScreen';
import { LoadingProvider } from './app/main/context/LoadingContext';
import { SiteSettingsProvider } from './app/main/context/SiteSettingsContext';
import { AuthProvider } from './app/main/context/AuthContext';
import ProtectedRoute from './app/main/components/ProtectedRoute';
import ScanShipmentScreen from './app/shipments_manager/views/ScanShipmentScreen';
import ServerErrorScreen from './app/error_handling/views/ServerErrorScreen';
import SendMessageScreen from './app/whatsapp/view/SendMessageScreen';

import DashboardScreen from './app/dashboard/views/DashboardScreen';
import PendingShipmentForm from './app/shipments_manager/views/widgets/PendingShipmentForm';
import SettingsScreen from './app/settings/views/SettingsScreen';
import GeneralSettingsScreen from './app/settings/views/GeneralSettingsScreen';
import PaymentSettingsScreen from './app/settings/views/PaymentSettingsScreen';
import TwilioSettingsScreen from './app/settings/views/TwilioSettingsScreen';
import WhatsAppMessagesScreen from './app/settings/views/WhatsAppMessagesScreen';
import WhatsAppChatBotScreen from './app/settings/views/WhatsAppChatBotScreen';
import ShipmentsConfigurationScreen from './app/settings/views/ShipmentsConfigurationScreen';
import PermissionsScreen from './app/settings/views/PermissionsScreen';
import RolesScreen from './app/settings/views/RolesScreen';
import UsersScreen from './app/settings/views/UsersScreen';
import UserRolesScreen from './app/settings/views/UserRolesScreen';
import ShipmentTypesScreen from './app/settings/views/ShipmentTypesScreen';
import PaymentsScreen from './app/settings/views/PaymentsScreen';
import LocationsScreen from './app/settings/views/LocationsScreen';
import AccountsScreen from './app/settings/views/AccountsScreen';
import ReceiverDetailsScreen from './app/settings/views/ReceiverDetailsScreen';
import TrackingEventManagerScreen from './app/tracking_event/views/TrackingEventManagerScreen';
import ShipmentTrackingScreen from './app/tracking_event/views/ShipmentTrackingScreen';
import AddTrackingEventScreen from './app/tracking_event/views/AddTrackingEventScreen';
import EditTrackingEventScreen from './app/tracking_event/views/EditTrackingEventScreen';
import ShipmentUnitManagerScreen from './app/shipment_unit/views/ShipmentUnitManagerScreen';
import ShipmentUnitTrackingEventManagerScreen from './app/shipment_unit_tracking_event/views/ShipmentUnitTrackingEventManagerScreen';
import TrackingEventTypesMasterScreen from './app/tracking_event/views/TrackingEventTypesMasterScreen';
import ShippingCompaniesMasterScreen from './app/shipping_company/views/ShippingCompaniesMasterScreen';
import ShippingWarehousesMasterScreen from './app/shipping_warehouse/views/ShippingWarehousesMasterScreen';
import ScanPieceScreen from './app/shipment_pieces/views/ScanPieceScreen';
import ShipmentPiecesManagerScreen from './app/shipment_pieces/views/ShipmentPiecesManagerScreen';
import ShipmentPieceTrackingEventsManagerScreen from './app/shipment_pieces/views/ShipmentPieceTrackingEventsManagerScreen';
import UniversalScannerScreen from './app/scan/views/UniversalScannerScreen';
import PublicPieceTrackingScreen from './app/public_tracking/views/PublicPieceTrackingScreen';
import PublicPieceTrackingLandingScreen from './app/public_tracking/views/PublicPieceTrackingLandingScreen';
import PublicInvoicePayScreen from './app/public_pay/views/PublicInvoicePayScreen';
import PaymentResultScreen from './app/public_pay/views/PaymentResultScreen';



function LegacyPricingRuleEditRedirect() {
  const { id } = useParams();
  return <Navigate to={`/PricingRules/${id}/Edit`} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <SiteSettingsProvider>
        <LoadingProvider>
          <MaterialThemeWithDataGridLocale>
            <JoyDirectionalCssVarsProvider>
              <CssBaseline enableColorScheme />
              <Routes>
            {/* ── Public & redirects ─────────────────────────────────────── */}
            <Route path="/" element={<Navigate to="/customer-home" replace />} />
            <Route path="/track" element={<PublicPieceTrackingLandingScreen />} />
            <Route path="/track/:barcode" element={<PublicPieceTrackingScreen />} />
            <Route path="/pay/i/:token" element={<PublicInvoicePayScreen />} />
            <Route path="/pay/result" element={<PaymentResultScreen />} />

            {/* ── Authentication ─────────────────────────────────────────── */}
            <Route path="/Login" element={<LoginScreen />} />
            <Route path="/customer-login" element={<CustomerLoginScreen />} />

            {/* ── Customer portal (shared layout — avoids remounting CustomerLayout per page) */}
            <Route
              element={
                <ProtectedRoute redirectTo="/customer-login">
                  <Outlet />
                </ProtectedRoute>
              }
            >
              <Route path="/customer-home" element={<CustomerHomeScreen />} />
              <Route path="/customer-shipments" element={<CustomerMyShipmentsScreen />} />
              <Route path="/customer-invoices" element={<CustomerMyInvoicesScreen />} />
              <Route path="/customer-payments" element={<CustomerMyPaymentsScreen />} />
              <Route path="/customer-shipment/:shipmentId/tracking" element={<CustomerShipmentTrackingScreen />} />
            </Route>

            {/* ── Staff: Overview ──────────────────────────────────────── */}
            <Route path="/home" element={
              <ProtectedRoute>
                <HomeScreen />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Shipments — core operations ───────────────────── */}
            <Route path="/Shipments" element={
              <ProtectedRoute>
                <ShipmentManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="Shipment/AddShipment" element={
              <ProtectedRoute>
                <AddShipmentScreen />
              </ProtectedRoute>
            } />
            <Route path="Shipment/:id/EditShipment" element={
              <ProtectedRoute>
                <EditShipmentScreen />
              </ProtectedRoute>
            } />
            <Route path="Shipment/Import" element={
              <ProtectedRoute>
                <ImportShipmentsScreen />
              </ProtectedRoute>
            } />
            <Route path="Shipment/PendingShipmentForm" element={
              <ProtectedRoute>
                <PendingShipmentForm />
              </ProtectedRoute>
            } />

            {/* ── Staff: Shipments — scanning (piece → shipment) ───────── */}
            <Route path="/shipment/pieces/scan" element={
              <ProtectedRoute>
                <ScanPieceScreen />
              </ProtectedRoute>
            } />
            <Route path="Shipment/Scan" element={
              <ProtectedRoute>
                <ScanShipmentScreen />
              </ProtectedRoute>
            } />
            <Route path="/scan" element={
              <ProtectedRoute>
                <UniversalScannerScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Shipments — tracking (piece → shipment → unit) ── */}
            <Route path="/shipment/piece-tracking-events" element={
              <ProtectedRoute>
                <ShipmentPieceTrackingEventsManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="/shipment/tracking-events" element={
              <ProtectedRoute>
                <TrackingEventManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="/shipment/:shipmentId/tracking" element={
              <ProtectedRoute>
                <ShipmentTrackingScreen />
              </ProtectedRoute>
            } />
            <Route path="/shipment/tracking-events/add" element={
              <ProtectedRoute>
                <AddTrackingEventScreen />
              </ProtectedRoute>
            } />
            <Route path="/shipment/tracking-events/:id/edit" element={
              <ProtectedRoute>
                <EditTrackingEventScreen />
              </ProtectedRoute>
            } />
            <Route path="/shipment/unit-tracking-events" element={
              <ProtectedRoute>
                <ShipmentUnitTrackingEventManagerScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Shipments — inventory (piece → shipment → unit) ── */}
            <Route path="/shipment/pieces" element={
              <ProtectedRoute>
                <ShipmentPiecesManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="/shipment/receiver-details" element={
              <ProtectedRoute>
                <ReceiverDetailsScreen />
              </ProtectedRoute>
            } />
            <Route path="/shipment/units" element={
              <ProtectedRoute>
                <ShipmentUnitManagerScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Finance ───────────────────────────────────────── */}
            <Route path="/services" element={<Navigate to="/PricingRules" replace />} />
            <Route path="/Services" element={<Navigate to="/PricingRules" replace />} />
            <Route path="/services/AddService" element={<Navigate to="/PricingRules/Add" replace />} />
            <Route path="/Services/AddService" element={<Navigate to="/PricingRules/Add" replace />} />
            <Route path="/services/:id/EditService" element={<LegacyPricingRuleEditRedirect />} />
            <Route path="/Services/:id/EditService" element={<LegacyPricingRuleEditRedirect />} />
            <Route path="Services/:id/EditService" element={<LegacyPricingRuleEditRedirect />} />
            <Route path="/PricingRules" element={
              <ProtectedRoute>
                <PricingRulesManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="/PricingRules/Add" element={
              <ProtectedRoute>
                <AddPricingRuleScreen />
              </ProtectedRoute>
            } />
            <Route path="/PricingRules/Import" element={
              <ProtectedRoute>
                <ImportPricingRulesScreen />
              </ProtectedRoute>
            } />
            <Route path="/PricingRules/:id/Edit" element={
              <ProtectedRoute>
                <EditPricingRuleScreen />
              </ProtectedRoute>
            } />
            <Route path="/PricingPlans" element={
              <ProtectedRoute>
                <PricingPlansManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="/PricingPlans/Add" element={
              <ProtectedRoute>
                <AddPricingPlanScreen />
              </ProtectedRoute>
            } />
            <Route path="/PricingPlans/:id" element={
              <ProtectedRoute>
                <PricingPlanDetailScreen />
              </ProtectedRoute>
            } />
            <Route path="/Invoices" element={
              <ProtectedRoute>
                <InvoiceManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="/Invoices/AddInvoice" element={
              <ProtectedRoute>
                <AddInvoiceScreen />
              </ProtectedRoute>
            } />
            <Route path="Invoices/:id/EditInvoice" element={
              <ProtectedRoute>
                <EditInvoiceScreen />
              </ProtectedRoute>
            } />
            <Route path="/payments" element={
              <ProtectedRoute>
                <PaymentsScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Customers ─────────────────────────────────────── */}
            <Route path="/Customers" element={
              <ProtectedRoute>
                <CustomerManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="/Customers/AddCustomer" element={
              <ProtectedRoute>
                <AddCustomerScreen />
              </ProtectedRoute>
            } />
            <Route path="Customers/:id/EditCustomer" element={
              <ProtectedRoute>
                <EditCustomerScreen />
              </ProtectedRoute>
            } />
            <Route path="/customers/pending-registrations" element={
              <ProtectedRoute>
                <CustomerRegistrationApprovalsScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Messaging ─────────────────────────────────────── */}
            <Route path="/SendMessage" element={
              <ProtectedRoute>
                <SendMessageScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Settings — site & integrations ─────────────────── */}
            <Route path="/settings" element={
              <ProtectedRoute>
                <SettingsScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/general" element={
              <ProtectedRoute>
                <GeneralSettingsScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/payment" element={
              <ProtectedRoute>
                <PaymentSettingsScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/shipments-config" element={
              <ProtectedRoute>
                <ShipmentsConfigurationScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/twilio" element={
              <ProtectedRoute>
                <TwilioSettingsScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/whatsapp-messages" element={
              <ProtectedRoute>
                <WhatsAppMessagesScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/whatsapp-chatbot" element={
              <ProtectedRoute>
                <WhatsAppChatBotScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Settings — access control ──────────────────────── */}
            <Route path="/settings/permissions" element={
              <ProtectedRoute>
                <PermissionsScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/roles" element={
              <ProtectedRoute>
                <RolesScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/users" element={
              <ProtectedRoute>
                <UsersScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/user-roles" element={
              <ProtectedRoute>
                <UserRolesScreen />
              </ProtectedRoute>
            } />

            {/* ── Staff: Settings — master data ─────────────────────────── */}
            <Route path="/settings/tracking-event-types" element={
              <ProtectedRoute>
                <TrackingEventTypesMasterScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/shipping-companies" element={
              <ProtectedRoute>
                <ShippingCompaniesMasterScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/shipping-warehouses" element={
              <ProtectedRoute>
                <ShippingWarehousesMasterScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/shipment-types" element={
              <ProtectedRoute>
                <ShipmentTypesScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/locations" element={
              <ProtectedRoute>
                <LocationsScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/accounts" element={
              <ProtectedRoute>
                <AccountsScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/settlementgroups" element={
              <ProtectedRoute>
                <SettlementGroupsManagerScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/settlementgroups/Add" element={
              <ProtectedRoute>
                <AddSettlementGroupScreen />
              </ProtectedRoute>
            } />
            <Route path="/settings/settlementgroups/:id" element={
              <ProtectedRoute>
                <SettlementGroupDetailScreen />
              </ProtectedRoute>
            } />

            {/* ── Errors ───────────────────────────────────────────────── */}
            <Route path="/ServerError" element={<ServerErrorScreen />} />

                      </Routes>
          </JoyDirectionalCssVarsProvider>
        </MaterialThemeWithDataGridLocale>
      </LoadingProvider>
    </SiteSettingsProvider>
    </AuthProvider>
  );
}